module.exports = __webpack_public_path__ + "static/media/onboarding-customer-preferences.399e605c.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/onboarding-customer-preferences.png
// module id = 2637
// module chunks = 0